import { runtime } from '../data/runtime';

const SITE_URL = runtime.SITE_URL;
const ORG_ID = `${SITE_URL}/#organization`;
const BUSINESS_ID = `${SITE_URL}/#business`;

export const organizationSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': ORG_ID,
  name: runtime.BUSINESS.name,
  url: `${SITE_URL}/`,
  logo: runtime.BUSINESS.logo,
  email: runtime.BUSINESS.email,
  sameAs: [runtime.BUSINESS.facebook, runtime.BUSINESS.playStore].filter(Boolean),
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: runtime.BUSINESS.phone,
    contactType: 'customer service',
    areaServed: 'AE',
    availableLanguage: ['English']
  }
});

// Service-area business: no street address is published because customers are
// served at their own location. Do not add ratings or reviews unless they are
// collected and displayed on this site in line with Google's guidelines.
export const businessSchema = (cityIds = runtime.CITIES.map((c) => c.id)) => ({
  '@context': 'https://schema.org',
  '@type': 'AutoWash',
  '@id': BUSINESS_ID,
  name: runtime.BUSINESS.name,
  url: `${SITE_URL}/`,
  image: runtime.BUSINESS.ogImage,
  logo: runtime.BUSINESS.logo,
  telephone: runtime.BUSINESS.phone,
  email: runtime.BUSINESS.email,
  priceRange: 'AED 30 - AED 65',
  parentOrganization: { '@id': ORG_ID },
  areaServed: runtime.CITIES.filter((c) => cityIds.includes(c.id)).map((c) => ({
    '@type': 'City',
    name: c.name,
    containedInPlace: { '@type': 'Country', name: 'United Arab Emirates' }
  }))
});

export const serviceSchema = ({ name, description, path, offers = [] }) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  name,
  description,
  url: `${SITE_URL}${path}`,
  serviceType: name,
  provider: { '@id': BUSINESS_ID },
  areaServed: runtime.CITIES.map((c) => ({ '@type': 'City', name: c.name })),
  ...(offers.length && {
    offers: offers.map((o) => ({
      '@type': 'Offer',
      name: o.name,
      price: o.price,
      priceCurrency: 'AED',
      url: `${SITE_URL}${path}`
    }))
  })
});

// Helps Google show "Quick Way" as the site name in results.
export const websiteSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': `${SITE_URL}/#website`,
  name: runtime.BUSINESS.name,
  alternateName: ['Quick Way Car Wash', 'Quickways'],
  url: `${SITE_URL}/`,
  publisher: { '@id': ORG_ID }
});

export const faqSchema = (items = []) => (items.length ? {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: items.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a }
  }))
} : null);

// No aggregateRating: only add one if real Play Store ratings are shown on the page.
export const appSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'MobileApplication',
  name: 'Quick Way - Mobile Car Wash',
  operatingSystem: 'ANDROID',
  applicationCategory: 'LifestyleApplication',
  url: `${SITE_URL}/car-wash-app`,
  downloadUrl: runtime.BUSINESS.playStore,
  installUrl: runtime.BUSINESS.playStore,
  image: runtime.BUSINESS.logo,
  publisher: { '@id': ORG_ID },
  offers: { '@type': 'Offer', price: 0, priceCurrency: 'AED' }
});

export const breadcrumbSchema = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: item.name,
    item: `${SITE_URL}${item.path}`
  }))
});
